const bridge = () =>
  typeof window !== "undefined" ? window.desktopOfflineLoyalty : null;

const cleanError = (error) => {
  const message = String(error?.message || error || "Offline loyalty operation failed.")
    .replace(/^Error invoking remote method '[^']+':\s*(?:Error:\s*)?/i, "")
    .replace(/^Error:\s*/i, "")
    .trim();
  return new Error(message || "Offline loyalty operation failed.");
};

const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline loyalty settings.");
  return api;
};

export const getOfflineLoyaltySettings = async (restaurantId) => {
  try {
    return await requireBridge().get({ restaurantId });
  } catch (error) {
    throw cleanError(error);
  }
};

export const saveOfflineLoyaltySettings = async (restaurantId, payload) => {
  try {
    return await requireBridge().save({ ...payload, restaurantId });
  } catch (error) {
    throw cleanError(error);
  }
};
